/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type DonateHeartsControlsContainer_charity$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CharityContainer_charity$ref: FragmentReference;
export type CharityContainer_charity = {|
  +id: string,
  +description: ?string,
  +logo: ?string,
  +name: ?string,
  +website: ?string,
  +$fragmentRefs: DonateHeartsControlsContainer_charity$ref,
  +$refType: CharityContainer_charity$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "CharityContainer_charity",
  "type": "Charity",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "logo",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "website",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "DonateHeartsControlsContainer_charity",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4f54fe6a40bcb6a02b0aed5c94ec91ba';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Donate/__generated__/CharityContainer_charity.graphql.js